function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.8887 7.85648C21.6214 7.03944 20.9102 6.44404 20.0542 6.3205L15.2059 5.62087L13.038 1.2581C12.6552 0.487673 11.8652 0 11.0002 0H11.0001C10.1352 0 9.34509 0.487733 8.96226 1.25804L6.79418 5.62087L1.94582 6.3205C1.08981 6.44404 0.378599 7.0395 0.111268 7.85648C-0.156002 8.67351 0.0669353 9.57037 0.686327 10.17L4.19458 13.5662L3.36618 18.3615C3.21991 19.2082 3.5704 20.064 4.27022 20.5689C4.9701 21.0739 5.89789 21.1405 6.66354 20.7407L11.0001 18.4766L15.3367 20.7407C15.6692 20.9144 16.0322 21 16.3939 21C16.8651 21 17.334 20.8546 17.73 20.5689C18.4299 20.0639 18.7803 19.2082 18.634 18.3615L17.8056 13.5662L21.3138 10.1699C21.9331 9.57031 22.156 8.67345 21.8887 7.85648Z",
  fill: "#E5E5E5"
});

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.d4a14e194cbaa4341479fdea3f34d33d.svg";
export { ForwardRef as ReactComponent };